
















import { Component, Inject, Vue } from "vue-property-decorator";
import { IClientProviderData } from "@/models/providers/client";
import { RegexMatch } from "@/data/enums/router";
import { QUERY_PARAMS } from "@/data/constants";

@Component({
  components: {
    "orders-listing": () =>
      import("@/components/app/global/orders/ordersListing.vue")
  }
})
export default class AdminClientOrders extends Vue {
  // Inject

  @Inject({ from: "clientProvider" })
  public readonly $clientProvider!: () => IClientProviderData;

  // Computed

  public get $client() {
    return this.$clientProvider();
  }

  public get adminOrderRoute() {
    return {
      name: "adminOrderShop",
      params: { basketId: RegexMatch.NEW },
      query: {
        [QUERY_PARAMS.CLIENT_ID]: this.$client.clientId,
        [QUERY_PARAMS.ACCOUNT_ID]: this.$client.accountId
      }
    };
  }
}
